<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr } from '../../../common/util';
  import { getServicesInfo } from '../services/pdp-data-services';
  import { openServicesInfoPopup } from '../store/pdp_store';

  export let data: any;
  export let showLearnMore = false;
  export let serviceBlockType;

  const { encodedContextPath, productDetails } = getAppConfig();

  const serviceIncludedClicked = () => {
    getServicesInfo(productDetails.code, serviceBlockType, false);
    $openServicesInfoPopup = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
</script>

<section class="pdp-service-mini-card">
  <section class="title">
    <!-- <img src={data?.imageUrl} alt={data?.label} /> -->
    {#if data?.label}
      <h3>{data.label}</h3>
    {/if}
    {#if !showLearnMore}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="whats-included-link" on:click={() => serviceIncludedClicked()}>
        {getStr('extra.pdp.service.whatsincluded')}
      </div>
    {/if}
  </section>
  <section class="subtitle">
    {#if data?.content}
      <p>{@html data?.content}</p>
    {/if}
  </section>
  {#if data?.code === 'servicesAppleCarePDPContent' || showLearnMore}
    <a href="{encodedContextPath}{data?.url}" class="learn-more">{getStr('extra.vas.service.learn.more')}</a>
  {/if}
  <section class="content">
    <slot></slot>
  </section>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .pdp-service-mini-card {
    padding: 8px;
    border-radius: 8px;
    background-color: $primary-white;
    .learn-more {
      color: $tertiary-blue-02;
      display: flex;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      margin-top: 8px;
    }

    .title {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        height: 20px;
        object-fit: contain;
      }
      h3 {
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        color: $neutral-dark-01;
        margin: 0;
        flex-grow: 1;
      }
      a {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: $icon-only-icon-blue;
      }
    }
    .subtitle {
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: $neutral-dark-03;
    }

    .whats-included-link {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: $icon-only-icon-blue;
      cursor: pointer;
    }
  }
</style>
